import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { BarrioModel } from '../../models/barrio.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BarrioService extends BaseService<BarrioModel> {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Barrio';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.barrio}`;
   }
}
